export const translations = {
  sv: {
    // Navigation
    nav: {
      home: "Hem",
      products: "Produkter",
      about: "Om oss",
      contact: "Kontakt",
      jobs: "Karriär",
      library: "Bibliotek",
      admin: "Admin"
    },
    // Hero
    hero: {
      tagline: "Din partner för professionella VVS-produkter och konsultlösningar",
      cta: "Utforska produkter",
      jobsCta: "Se karriärmöjligheter"
    },
    // Products
    products: {
      title: "Produktkatalog",
      filter: "Filtrera",
      category: "Kategori",
      dimension: "Dimension",
      material: "Material",
      pressureClass: "Tryckklass",
      allCategories: "Alla kategorier",
      allDimensions: "Alla dimensioner",
      allMaterials: "Alla material",
      allPressureClasses: "Alla tryckklasser",
      requestQuote: "Begär offert",
      variants: "Varianter",
      specifications: "Specifikationer",
      documents: "Dokument",
      download: "Ladda ner",
      noProducts: "Inga produkter hittades",
      featured: "Utvalda produkter"
    },
    // Product detail
    productDetail: {
      articleNumber: "Artikelnummer",
      dimension: "Dimension",
      connection: "Anslutning",
      material: "Material",
      pn: "PN",
      price: "Pris"
    },
    // Jobs
    jobs: {
      title: "Lediga tjänster och konsultuppdrag",
      subtitle: "Bli en del av Flowingo-teamet",
      filter: "Filtrera",
      location: "Ort",
      roleType: "Anställningstyp",
      experienceLevel: "Erfarenhetsnivå",
      jobCategory: "Kategori",
      allLocations: "Alla orter",
      allRoleTypes: "Alla typer",
      allExperienceLevels: "Alla nivåer",
      allCategories: "Alla kategorier",
      apply: "Ansök nu",
      deadline: "Ansök senast",
      requirements: "Krav",
      qualifications: "Kvalifikationer",
      description: "Beskrivning",
      noJobs: "Inga lediga tjänster just nu",
      sortBy: "Sortera efter",
      newest: "Senaste först",
      deadline: "Deadline",
      newJob: "Nytt"
    },
    // Application
    application: {
      title: "Skicka din ansökan",
      firstName: "Förnamn",
      lastName: "Efternamn",
      email: "E-post",
      phone: "Telefon",
      message: "Meddelande (valfritt)",
      uploadCv: "Ladda upp CV",
      submit: "Skicka ansökan",
      success: "Tack för din ansökan!",
      error: "Något gick fel. Försök igen."
    },
    // About
    about: {
      title: "Om Flowingo AB",
      intro: "Flowingo AB är en ledande svensk leverantör av VVS-produkter för proffsmarknaden.",
      vision: "Vår vision",
      visionText: "Att vara den mest pålitliga partnern för VVS-proffs i Norden genom kvalitetsprodukter och expertis.",
      values: "Våra värderingar",
      valuesText: "Kvalitet, pålitlighet och partnerskap genomsyrar allt vi gör.",
      b2b: "B2B-fokus",
      b2bText: "Vi arbetar nära grossister, installatörer och fastighetsbolag för att leverera rätt produkter i rätt tid."
    },
    // Contact
    contact: {
      title: "Kontakta oss",
      subtitle: "Vårt team",
      email: "E-post",
      phone: "Telefon"
    },
    // Footer
    footer: {
      address: "Solventilsgatan 17D, 417 24 Göteborg",
      phone: "+46(0)31 27 32 32",
      email: "info@flowingo.se",
      rights: "© 2025 Flowingo AB. Alla rättigheter förbehållna."
    },
    // Categories
    categories: {
      ventiler: "Ventiler",
      rordelar: "Rördelar",
      styrsystem: "Styrsystem",
      varmeprodukter: "Värmeprodukter"
    },
    // Role types
    roleTypes: {
      Konsultuppdrag: "Konsultuppdrag",
      Heltid: "Heltid",
      Deltid: "Deltid"
    },
    // Experience levels
    experienceLevels: {
      Junior: "Junior",
      Mid: "Mid-level",
      Senior: "Senior"
    },
    // Common
    common: {
      loading: "Laddar...",
      error: "Ett fel uppstod",
      back: "Tillbaka",
      readMore: "Läs mer",
      seeAll: "Se alla"
    },
    // Library
    library: {
      title: "Bibliotek",
      subtitle: "Tekniska resurser och nedladdningar",
      description: "Ladda ner produktkataloger, tekniska manualer, mjukvara och certifikat",
      search: "Sök i biblioteket...",
      filterByCategory: "Filtrera efter kategori",
      filterByType: "Filtrera efter filtyp",
      allCategories: "Alla kategorier",
      allTypes: "Alla filtyper",
      download: "Ladda ner",
      fileSize: "Filstorlek",
      version: "Version",
      language: "Språk",
      compatibility: "Kompatibilitet",
      uploadedDate: "Uppladdad",
      noDocuments: "Inga dokument hittades"
    }
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      products: "Products",
      about: "About",
      contact: "Contact",
      jobs: "Careers",
      library: "Library",
      admin: "Admin"
    },
    // Hero
    hero: {
      tagline: "Your partner for professional HVAC products and consulting solutions",
      cta: "Explore products",
      jobsCta: "View open positions"
    },
    // Products
    products: {
      title: "Product Catalog",
      filter: "Filter",
      category: "Category",
      dimension: "Dimension",
      material: "Material",
      pressureClass: "Pressure Class",
      allCategories: "All categories",
      allDimensions: "All dimensions",
      allMaterials: "All materials",
      allPressureClasses: "All pressure classes",
      requestQuote: "Request quote",
      variants: "Variants",
      specifications: "Specifications",
      documents: "Documents",
      download: "Download",
      noProducts: "No products found",
      featured: "Featured products"
    },
    // Product detail
    productDetail: {
      articleNumber: "Article Number",
      dimension: "Dimension",
      connection: "Connection",
      material: "Material",
      pn: "PN",
      price: "Price"
    },
    // Jobs
    jobs: {
      title: "Open positions & consulting assignments",
      subtitle: "Join the Flowingo team",
      filter: "Filter",
      location: "Location",
      roleType: "Employment type",
      experienceLevel: "Experience level",
      jobCategory: "Category",
      allLocations: "All locations",
      allRoleTypes: "All types",
      allExperienceLevels: "All levels",
      allCategories: "All categories",
      apply: "Apply now",
      deadline: "Apply by",
      requirements: "Requirements",
      qualifications: "Qualifications",
      description: "Description",
      noJobs: "No open positions at the moment",
      sortBy: "Sort by",
      newest: "Newest first",
      newJob: "New"
    },
    // Application
    application: {
      title: "Submit your application",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone",
      message: "Message (optional)",
      uploadCv: "Upload CV",
      submit: "Submit application",
      success: "Thank you for your application!",
      error: "Something went wrong. Please try again."
    },
    // About
    about: {
      title: "About Flowingo AB",
      intro: "Flowingo AB is a leading Swedish supplier of HVAC products for the professional market.",
      vision: "Our vision",
      visionText: "To be the most reliable partner for HVAC professionals in the Nordic region through quality products and expertise.",
      values: "Our values",
      valuesText: "Quality, reliability and partnership permeate everything we do.",
      b2b: "B2B focus",
      b2bText: "We work closely with wholesalers, installers and property companies to deliver the right products at the right time."
    },
    // Contact
    contact: {
      title: "Contact us",
      subtitle: "Our team",
      email: "Email",
      phone: "Phone"
    },
    // Footer
    footer: {
      address: "Solventilsgatan 17D, 417 24 Göteborg",
      phone: "+46(0)31 27 32 32",
      email: "info@flowingo.se",
      rights: "© 2025 Flowingo AB. All rights reserved."
    },
    // Categories
    categories: {
      ventiler: "Valves",
      rordelar: "Pipe Fittings",
      styrsystem: "Control Systems",
      varmeprodukter: "Heating Products"
    },
    // Role types
    roleTypes: {
      Konsultuppdrag: "Consulting",
      Heltid: "Full-time",
      Deltid: "Part-time"
    },
    // Experience levels
    experienceLevels: {
      Junior: "Junior",
      Mid: "Mid-level",
      Senior: "Senior"
    },
    // Common
    common: {
      loading: "Loading...",
      error: "An error occurred",
      back: "Back",
      readMore: "Read more",
      seeAll: "See all"
    },
    // Library
    library: {
      title: "Library",
      subtitle: "Technical resources and downloads",
      description: "Download product catalogs, technical manuals, software and certificates",
      search: "Search library...",
      filterByCategory: "Filter by category",
      filterByType: "Filter by file type",
      allCategories: "All categories",
      allTypes: "All file types",
      download: "Download",
      fileSize: "File size",
      version: "Version",
      language: "Language",
      compatibility: "Compatibility",
      uploadedDate: "Uploaded",
      noDocuments: "No documents found"
    }
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang];
  for (const k of keys) {
    value = value?.[k];
  }
  return value || key;
};
